import { Component, OnInit, OnDestroy, Sanitizer } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { CoursewareService } from 'src/services/CoursewareService';
import { AlertService } from '../_alert';
import { FeaturedContent } from 'src/model/FeaturedContent/FeaturedContent';
import { Error } from 'src/model/Error';
import { ContentArea } from 'src/model/FeaturedContent/ContentArea';
import { globals } from '../shared/globals';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { MetaService } from 'src/services/MetaService';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  providers: [
    { provide: CarouselConfig, useValue: { interval: 10000, noPause: true, showIndicators: true } }],
  styleUrls: ['./home.component.css']
})

export class HomeComponent extends BaseComponent implements OnInit, OnDestroy {
  public featuredContent: FeaturedContent[];
  public width: number;

  constructor(private canonicalService: MetaService, private titleService: Title, private _router: Router, private sanitizer: DomSanitizer, private coursewareService: CoursewareService, private alertService: AlertService) {
    super();
    this.titleService.setTitle("LawShelf Educational Media");
    this.canonicalService.addMetaTags(null, "Our mission is to provide high-quality videos and articles to help people learn about the law. LawShelf is a project of National Paralegal College.", "https://lawshelf.com/assets/img/certificates-img.png", "Lawshelf Educational Media", null);
  }

  ngOnDestroy(): void {
    this.canonicalService.removeCanonicalURL();
  }

  ngOnInit() {
    this.pushAllAds(2);
    if (typeof window !== 'undefined') {
      this.width = window.innerWidth;
    }
    this.alertService.clear();
    this.coursewareService.GetFeaturedContent().subscribe(data => {
      this.featuredContent = data;
      if (!this.featuredContent || !this.featuredContent.length) {
        this.featuredContent = null;
        let error: Error = data;
        this.alertService.error(error.Message);
      }
    },
      error => this.alertService.error("Got an unexpected error when retrieving featured content " + error.error));

    this.canonicalService.createCanonicalURL(this._router.url, "/homeview/");
  }

  public getEntryImageUrl(ThumbnailFileName) {
    return this.sanitizer.bypassSecurityTrustResourceUrl("/assets/databaseimages/" + ThumbnailFileName);
    //        return this.sanitizer.bypassSecurityTrustResourceUrl(globals.REMOTEHOST +  "/assets/databaseimages/" + ThumbnailFileName);
  }

  public getSlideClass(i) {
    if (i === 0) {
      return "carousel-item active";
    }
    return "carousel-item";
  }


  public getDestination(contentArea: ContentArea, alias: string) {
    if (contentArea === 3) {
      return this.sanitizer.bypassSecurityTrustUrl("/videocoursescontentview/" + alias);
    }
    if (contentArea === 2) {
      return this.sanitizer.bypassSecurityTrustUrl("/shortvideoscontentview/" + alias);
    }
    if (contentArea === 1) {
      return this.sanitizer.bypassSecurityTrustUrl("/blogentryview/" + alias);
    }
  }

}
